import { useTranslation } from "react-i18next";

/** The arguments of a pending action, one row per parameter. */
export function ParamTable({ args }) {
  const { t } = useTranslation();
  return (
    <div className="ds-table-wrap">
      <table className="ds-table">
        <thead><tr><th>{t("agents.parameter")}</th><th>{t("agents.value")}</th></tr></thead>
        <tbody>
          {Object.entries(args || {}).map(([key, value]) => (
            <tr key={key}><td className="ds-mono">{key}</td>
              <td className="ds-mono">{typeof value === "string" ? value : JSON.stringify(value)}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Whether `user` may approve or reject the run's pending action (mirrors the API's rule:
 * the owner decides their own actions; a second-approver action needs another admin). */
export function mayDecide(run, user) {
  const second = run.pending_action && run.pending_action.requires_second_approver;
  return second ? user?.role === "admin" && user?.id !== run.user_id : user?.id === run.user_id;
}

/** The exact action a run waits on, with approve / reject (and a reason) for whoever may decide. */
export default function ApprovalPanel({ run, user, busy, reason, onReason, onDecide }) {
  const { t } = useTranslation();
  const pending = run.pending_action;
  if (run.status !== "awaiting_approval" || !pending) return null;
  return (
    <div className="agent-approval" role="group" aria-label={t("agents.approvalRequired")}>
      <p className="agent-approval-action">
        {t("agents.approvalRequired")}: <strong className="ds-mono">{pending.tool}</strong>
      </p>
      <ParamTable args={pending.arguments} />
      {mayDecide(run, user) ? (
        <div className="ds-toolbar ac-toolbar-flush">
          <div className="ds-field ac-grow">
            <label className="ds-label" htmlFor={`agent-reason-${run.id}`}>{t("agents.reason")}</label>
            <input id={`agent-reason-${run.id}`} className="ds-input" placeholder={t("agents.reasonPlaceholder")}
                   value={reason || ""} onChange={(e) => onReason(e.target.value)} />
          </div>
          <button type="button" className="ds-btn ds-btn--primary" disabled={busy}
                  onClick={() => onDecide("approve")}>{t("agents.approve")}</button>
          <button type="button" className="ds-btn ds-btn--danger" disabled={busy}
                  onClick={() => onDecide("reject")}>{t("agents.reject")}</button>
        </div>
      ) : (
        <p className="ds-help">{t(pending.requires_second_approver ? "agents.secondApprover" : "agents.onlyOwner")}</p>
      )}
    </div>
  );
}
